import React, { useState, useEffect } from 'react';

const TestimonialsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [transitionDirection, setTransitionDirection] = useState('next');
  const testimonials = [
    {
      name: "Md. Mahabub Alam",
      role: "Founder & Lead Developer",
      image: "assets/images/Testimonial/testimonial_6.webp",
      rating: 4,
      review: "This one has been my best experience so far. The theme works great and support was QUICKLY responsive.",
    },
    {
      name: "Anna White",
      role: "UI/UX Designer",
      image: "assets/images/Testimonial/testimonial_1.webp",
      rating: 5,
      review: "Excellent theme! Modern design, easy to use, and extremely customizable.",
    },
    {
      name: "John Doe",
      role: "Marketing Head",
      image: "assets/images/Testimonial/testimonial_2.webp",
      rating: 4,
      review: "I love how intuitive this platform is. Saved us tons of time in deployment.",
    },
    {
      name: "Sarah Khan",
      role: "Entrepreneur",
      image: "assets/images/Testimonial/testimonial_3.webp",
      rating: 5,
      review: "Support was fantastic! They added features I requested almost instantly.",
    },
    {
      name: "Carlos Mendez",
      role: "Full Stack Developer",
      image: "assets/images/Testimonial/testimonial_4.webp",
      rating: 4,
      review: "Clean code and very flexible theme. Documentation is top-notch.",
    },
    {
      name: "Nina Patel",
      role: "Startup Founder",
      image: "assets/images/Testimonial/testimonial_5.webp",
      rating: 5,
      review: "Best purchase on ThemeForest to date. High quality and easy integration.",
    },
  ];

  // Auto-rotate every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 4000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const handleNext = () => {
    setTransitionDirection('next');
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setTransitionDirection('prev');
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Get visible testimonials based on current index
  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentIndex + i) % testimonials.length;
      visible.push({
        ...testimonials[index],
        position: i, // 0: left, 1: center, 2: right
        active: i === 1 // center card is active
      });
    }
    return visible;
  };

  return (
    <section className="py-4 px-3 bg-light">
  <div className="container text-center">
    <h2 className="mb-5" style={{color: "#200D46"}}>Parents Testimonial</h2>

    <div className="position-relative mb-4">
      <div className="row g-4" style={{ minHeight: '350px' }}>
        {getVisibleTestimonials().map((t, i) => (
          <div 
            key={`${t.name}-${i}`} 
            className={`col-12 col-md-6 col-lg-4 transition-all ${transitionDirection} ${
              t.active ? 'active' : 'd-none d-md-block inactive'
            }`}
            style={{
              transition: 'all 0.5s ease-in-out',
              transform: t.position === 0 ? 'translateX(-20px) scale(0.9)' : 
                         t.position === 2 ? 'translateX(20px) scale(0.9)' : 
                         'translateX(0) scale(1)',
              opacity: t.active ? 1 : 0.7,
              filter: t.active ? 'none' : 'brightness(0.95)'
            }}
          >
            <div className={`p-4 shadow rounded bg-white h-100 d-flex flex-column justify-content-between ${
              t.active ? 'border-primary border-2' : ''
            }`}>
              <i className="fa fa-quote-left fa-2x text-primary mb-3"></i>
              <p className="fs-6">{t.review}</p>
              <div className="d-flex align-items-center mt-4">
                <img
                  src={t.image}
                  alt={t.name}
                  className="rounded-circle me-3"
                  style={{ width: 50, height: 50, objectFit: "cover" }}
                />
                <div className="text-start">
                  <h6 className="mb-0 fw-bold">{t.name}</h6>
                  <small className="text-muted">{t.role}</small>
                  <div className="text-warning mt-1">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`fa ${i < t.rating ? "fa-star" : "fa-star-o"}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Navigation Buttons (only visible on small screens) */}
      <div className="d-flex d-md-none justify-content-center gap-3 mt-4">
        <button 
          className="btn btn-outline-primary rounded-circle"
          style={{ width: '40px', height: '40px' }}
          onClick={handlePrev}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button 
          className="btn btn-outline-primary rounded-circle"
          style={{ width: '40px', height: '40px' }}
          onClick={handleNext}
        >
          <i className="fa fa-chevron-right" />
        </button>
      </div>
    </div>
  </div>
</section>
  );
};

export default TestimonialsCarousel;